import DescriptionIcon from "@material-ui/icons/Description";
import StoreIcon from "@material-ui/icons/Store";
import DesktopMacIcon from "@material-ui/icons/DesktopMac";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import BugReportIcon from "@mui/icons-material/BugReport";

export const navBar = [
  {
    code: "Bán hàng",
    link: null,
    icon: <DescriptionIcon htmlColor="#01579b" />,
    submenu: [
      { code: "Phiếu xuất trả hàng gửi", link: "/fuelticket", key: "FuelTicket,List" },
      { code: "Hóa đơn GTGT", link: "/invoices", key: "Invoice,List" },
      { code: "Hóa đơn xuất từ ERP", link: "/erpinv", key: "ErpInv,List" },
      { code: "Hóa đơn thương mại", link: "/ci", key: "CommercialInvoice,List" },
    ],
  },
  {
    code: "Nhập mua hàng",
    link: null,
    icon: <LocalShippingIcon htmlColor="#01579b" />,
    submenu: [
      { code: "Nhập hàng nội địa", link: "/m23", key: "" },
      { code: "Bảng đối chiếu số lượng nhập mua hàng", link: "/report/rptm23truck", key: "" },
    ],
  },
  {
    code: "Vận chuyển nội bộ",
    link: null,
    icon: <LocalShippingIcon htmlColor="#01579b" />,
    submenu: [
      { code: "Thông tin hàng gửi từ kho đầu nguồn", link: "/extrpt", key: "ExtRpt,List" },
      { code: "Xuất nhập di chuyển nội bộ", link: "/ticket", key: "Receipt,View Export" },
      { code: "Bảng kê xuất nhập di chuyển nội bộ", link: "/rptticket", key: "Receipt,View Report" },
      { code: "Bảng đối chiếu số lượng nhập hàng xe xitec", link: "/report/rptimptruck", key: "Reporting,ImpTruck" },
      // { code: 'Nhập hàng nội địa', link: '/m23' }
    ],
  },
  null,
  {
    code: "Hoá đơn mua hàng",
    link: null,
    icon: <DescriptionIcon htmlColor="#01579b" />,
    submenu: [
      { code: "Hóa đơn chờ kiểm tra", link: "/pi", key: "PurchaseInvoice,List" },
      { code: "Hóa đơn đã kiểm tra", link: "/pi1", key: "PurchaseInvoice,List" },
      { code: "Hóa đơn đã duyệt", link: "/pi2", key: "PurchaseInvoice,List" },
    ],
  },
  null,
  {
    code: "Quản lý công nợ",
    link: null,
    icon: <LocalShippingIcon htmlColor="#01579b" />,
    submenu: [
      { code: "Thông tin hạn thanh toán", link: "/subso", key: "" },
      { code: "Thông tin thanh toán từ ERP", link: "/erppt", key: "ErpPt,List" },
      { code: "Thông tin khách hàng thanh toán", link: "/debt", key: "ErpPt,List" },
      { code: "Báo cáo tổng kết nợ của khách hàng", link: "/report/debt", key: "" },
      { code: "Báo cáo theo dõi lượng xuất CI", link: "/report/rptci", key: "" },
    ],
  },
  null,
  {
    code: "Sổ tay kỹ thuật",
    icon: <DesktopMacIcon htmlColor="#01579b" />,
    link: null,
    submenu: [
      { code: "Sổ theo dõi tra nạp", link: "/fuellogbox", key: "FuelLogBox,List" },
      { code: "Báo cáo KT.04.01", link: "/kt0401", key: "" },
    ],
  },
  null,
  {
    code: "Dữ liệu chung",
    icon: <StoreIcon htmlColor="#01579b" />,
    link: null,
    submenu: [
      { code: "Kho hàng", link: "/inventory", key: "" },
      { code: "Thông tin bồn/bể", link: "/tank", key: "" },

      { code: "Khách hàng", link: "/customers", key: "" },

      { code: "Mẫu hóa đơn", link: "/invoice-form", key: "" },
      { code: "Mẫu phiếu vận chuyển nội bộ", link: "/ltp", key: "" },
      { code: "Đơn bán hàng", link: "/sale-order", key: "" },
      { code: "Đơn mua hàng", link: "/po", key: "" },
      { code: "Tờ khai hải quan", link: "/ctmdocs", key: "" },

      { code: "Giá bán", link: "/price", key: "" },
      { code: "Ngân hàng", link: "/banks", key: "" },
      { code: "Tài khoản ngân hàng", link: "/bact", key: "" },
      { code: "Đơn vị tiền tệ", link: "/currency", key: "" },
      { code: "Nhiên liệu", link: "/product", key: "" },
      { code: "Đơn vị đo lường", link: "/product-unit", key: "" },

      { code: "Thông tin sân bay", link: "/airport", key: "" },
      { code: "Chuyến bay", link: "/flight", key: "" },
      { code: "Danh mục tàu bay", link: "/aircraft", key: "" },
      { code: "Đăng bạ tàu bay", link: "/acsreg", key: "" },
      { code: "Nhóm phương tiện", link: "/vehiclegroup", key: "" },
      { code: "Phương tiện", link: "/vehicle", key: "" },
      { code: "Đơn vị vận chuyển", link: "/provider", key: "" },
      { code: "Lái xe vận chuyển", link: "/driver", key: "" },

      { code: "Khu vực bán", link: "/salearea", key: "" },
      { code: "Loại hình bán", link: "/saletype", key: "" },
      { code: "Phương thức bán", link: "/loadingtype", key: "" },
      { code: "Ứng dụng di động", link: "/appid", key: "" },
    ],
  },
  null,
  {
    code: "Báo cáo tổng hợp",
    link: null,
    submenu: [
      { code: "Bảng kê tổng hợp số liệu xuất hóa đơn", link: "/report/rptsumtotalinv", key: "Reporting,TotalInvSum" },
      { code: "Bảng kê chi tiết xuất hóa đơn", link: "/report/rpttotalinv", key: "Reporting,TotalInv" },
      { code: "Bảng kê chi tiết chứng từ tại chi nhánh", link: "/report/rpttotalinvbybranch", key: "Reporting,TotalInv" },
    ],
  },
  null,
  {
    code: "Tổ chức - Người dùng",
    link: null,
    submenu: [
      { code: "Công ty/Chi nhánh", link: "/organization", key: "" },
      { code: "Phòng/Ban", link: "/department", key: "" },

      { code: "Nhóm người dùng", link: "/usergroup", key: "UserGroup,List" },
      { code: "Người dùng", link: "/user", key: "User,List" },
    ],
  },
  null,
  {
    code: "Hệ thống",
    link: null,
    submenu: [
      { code: "Cấu hình hệ thống", link: "/config", key: "" },
      { code: "Cấu hình ExtAPI", link: "/extapies", key: "ExtApies,List" },
      { code: "Cấu hình thời gian đồng bộ", link: "/synctime", key: "Sync,Sync" },
    ],
  },
  null,
  {
    code: "Log dữ liệu giao dịch",
    link: null,
    icon: <BugReportIcon htmlColor="#01579b" />,
    submenu: [
      { code: "Log giao dịch VNPT", link: "/log/vnpt", key: "" },
      { code: "Log giao dịch ERP", link: "/log/erp", key: "" },
    ],
  },
];
export var allRoutes = {};
const getAllRoutes = (i) => {
  if (!i) return;
  i.forEach((sub_i) => {
    if (sub_i?.link) allRoutes[sub_i.link] = sub_i.code;
    if (sub_i?.submenu?.length) getAllRoutes(sub_i?.submenu);
  });
};
getAllRoutes(navBar);
export const API_ACTIONS = [
  "ERP_INV POST",
  "ERP_INV PUT",
  "ERP_INV DELETE",
  "ERP_M23 POST",
  "ERP_M23 PUT",
  "ERP_M23 DELETE",
  "ERP_T3 POST",
  "ERP_T3 PUT",
  "ERP_T3 DELETE",
  "ERP_K2 POST",
  "ERP_K2 PUT",
  "ERP_K2 DELETE",
];
export const language = [
  { name: "English", code: "en" },
  { name: "Vietnam", code: "vi" },
];
export const saleFormConfig = [
  { label: "S11 - Tái xuất sân bay", loadingtype: 1, saletype: 1, sourcing: 21 },
  { label: "S31 - Nội địa sân bay", saletype: 3, loadingtype: 1, sourcing: 1 },
  { label: "SX - Xuất khẩu sân bay", saletype: 1, loadingtype: 1, sourcing: 1 },
];
export const SEARCH_INV = {
  NAPR: {
    code: "INV_APP",
    defaultSaleType: null,
    defaultLoadingType: null,
    create_link: null,
  },
  S11: {
    code: "INV_S11",
    defaultSaleType: 1,
    defaultLoadingType: 1,
    defaultSourcing: 21,
    create_link: "/invoices/create/s11",
  },
  S31: {
    code: "INV_S31",
    defaultSaleType: 3,
    defaultLoadingType: 1,
    defaultSourcing: 1,
    create_link: "/invoices/create/s31",
  },
  SX: {
    code: "INV_SX",
    defaultSaleType: 1,
    defaultLoadingType: 1,
    defaultSourcing: 1,
    create_link: "/invoices/create/sx",
  },
  S33: {
    code: "INV_S33",
    defaultSaleType: 3,
    defaultLoadingType: 3,
    defaultSourcing: 1,
    create_link: "/invoices/create/truck",
  },
  S15: {
    code: "INV_S15",
    defaultSaleType: 1,
    defaultLoadingType: 5,
    defaultSourcing: 21,
    create_link: "/invoices/create/s15",
  },
  OTHER: {
    code: "INV_OTHER",
    defaultSaleType: null,
    defaultLoadingType: null,
    defaultSourcing: null,
    create_link: null,
  },
};

export const statusColor = {
  PUBLISHED: "#1b5e20",
  DELETED: "#d32f2f",
  REPLACED: "#ED6C02",
  APPROVED: "#1b5e20",
  FAIL: "#29221d",
  CHECKING: "#506e52",
  CHECKED: "#224d39",
  "NOT CHECKED": "#c75eeb",
  "NOT APPROVED": "#4d4a22",
  ISSUED: "#346beb",
  CONSIGNMENT: "#331ddb",
};

export const inventoryCode = {
  "CN Cát Bi": ["HPH", "HPP", "Refueller"],
  "Tra nạp ngầm Nafsc (HAN)": ["HAN (NAFSC)", "HAN", "Hydrant System"],
  "CN Nội Bài": ["HAN", "HAN", "Refueller"],
  "CN Cam Ranh": ["CXR", "CXR", "Refueller"],
  "Chi Nhánh Hồ Chí Minh": ["SGN", "SGN", "Refueller"],
  "Tra nạp ngầm Tapetco (SGN)": ["SGN", "SGN", "Hydrant System"],
  "CN Đà Nẵng": ["DAD", "DAD", "Refueller"],
  "Điểm bán Điện Biên": ["DIN", "DIN", "Refueller"],
  "CN Liên Khương": ["DLI", "DLI", "Refueller"],
  "CN Phú Quốc": ["PQC", "PQC", "Refueller"],
};
export const FT_TYPE_REPLACE_URL = [null, "/fuelticket/replace/airft", "/fuelticket/replace/refuelertruckft", "/fuelticket/replace/truckft"];
export const ExtRptStatusOption = [
  { label: "DEACTIVATED", action: 0, label1: "DEACTIVATE" },
  { label: "ACTIVATED", action: 1, label1: "ACTIVATE" },
  { label: "APPROVED", action: 2, label1: "APPROVE" },
  { label: "DELETED", action: 4, label1: "DELETE" },
];

export const InvStatusOption = [
  { code: "PUBLISH", action: 1, label: "Phát hành" },
  { code: "APPROVED", action: 10, label: "Đã duyệt" },
  { code: "ADJUSTED", action: 2678, label: "Điều chỉnh" },
  { code: "REPLACED", action: 35, label: "Thay thế" },
  { code: "DELETED", action: 4, label: "Đã huỷ" },
];
export const moneyFormat = (value: number, currency) => value.toLocaleString(currency === "VND" ? "de-DE" : "ja-JP", { minimumFractionDigits: currency === "VND" ? 0 : 2 });
